import React from 'react';
import { FaFilePdf, FaImage, FaShare } from 'react-icons/fa';
import { trackEvent } from './common';
import { exportToPDF, exportAsCombinedImage } from './common';

const handleExportToPDF = (processedImages) => {
  trackEvent('export_pdf', 'Guardar como PDF');
  exportToPDF(processedImages);
};

const handleExportAsImage = (processedImages) => {
  trackEvent('export_image', 'Guardar como imagen');
  exportAsCombinedImage(processedImages);
};

const handleShare = (processedImages) => {
  const shareImage = async () => {
  trackEvent('share', 'Compartir');
  if (processedImages.length > 0) {
    try {
      
      const response = await fetch(processedImages[0]);
      const blob = await response.blob();
      const file = new File([blob], 'dni_seguro.jpg', { type: 'image/jpeg' });

      if (navigator.share) {
        await navigator.share({
          title: 'DNI Seguro',
          text: 'Mira esta imagen procesada con dniseguro.es',
          files: [file],
        });
      } else {
        console.log('Web Share API not supported');
      }
    } catch (error) {
      console.error('Error sharing image:', error);
    }
  }
}
};

function Result({ processedImages }) {
  return (
    <div className="w-100 py-4 text-white" style={{ backgroundColor: '#393E46' }}>
      <h2 className="mb-4 text-center">Comparte tu DNI seguro</h2>
      <div className="d-flex flex-wrap justify-content-center">
        {processedImages.map((image, index) => (
          <div key={index} className="m-2">
            <img 
              src={image} 
              alt={`DNI editado ${index + 1}`} 
              style={{ 
                maxWidth: '300px', 
                height: 'auto', 
                border: '4px solid white', 
                borderRadius: '10px' 
              }} 
            />
          </div>
        ))}
      </div>
      <div className='mt-4 d-flex justify-content-center'>
        <button className="btn mx-1 mb-2 rounded-pill" style={{ backgroundColor: '#222831', color: 'white' }} onClick={() => handleExportToPDF(processedImages)}>
          <FaFilePdf className='mx-1' style={{ color: '#fca311' }} />
          <span className="d-none d-md-inline">Guardar </span>PDF
        </button>
        <button className="btn mx-1 mb-2 rounded-pill" style={{ backgroundColor: '#222831', color: 'white' }} onClick={() => handleExportAsImage(processedImages)}>
          <FaImage className='mx-1' style={{ color: '#fca311' }} />
          <span className="d-none d-md-inline">Guardar </span>Imagen
        </button>
        {window.navigator.userAgent.match(/Android|iPhone|iPad|iPod/i) && (
          <button
            className="btn mx-1 mb-2 rounded-pill"
            style={{ backgroundColor: '#222831', color: 'white' }}
            onClick={() => handleShare(processedImages)}
          >
            <FaShare className='mx-1' style={{ color: '#fca311' }} />
            Compartir
          </button>
        )}
      </div>
    </div>
  );
}

export default Result;